import { CONTACT } from "../../data/site";
import logoBadge from "../../assets/logo_badge.png";

export const Footer = () => (
  <footer className="bg-[#1E1A17] text-[#F9F6F0] pt-20 pb-10 border-t border-[#3D352F]">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 border-b border-[#3D352F] pb-12">
        <div>
          <img src={logoBadge} alt="Mamta's Kitchen logo" className="h-20 w-20 md:h-24 md:w-24 object-contain mb-5" data-testid="footer-logo" />
          <p className="font-serif text-5xl md:text-7xl tracking-tight leading-none">Mamta's Kitchen</p>
          <p className="text-[#B4A79A] mt-4 max-w-sm">Handmade Indian pickles, cured with sunshine and patience in Ghaziabad.</p>
        </div>
        <div className="flex gap-12">
          <div>
            <p className="text-[11px] uppercase tracking-[0.2em] text-[#E28721] mb-3">Explore</p>
            <ul className="space-y-2 text-[#B4A79A]">
              <li><a href="#pickles" className="hover:text-[#F9F6F0] transition-colors">Pickles</a></li>
              <li><a href="#promise" className="hover:text-[#F9F6F0] transition-colors">Our Promise</a></li>
              <li><a href="#story" className="hover:text-[#F9F6F0] transition-colors">Her Story</a></li>
              <li><a href="#order" className="hover:text-[#F9F6F0] transition-colors">Order</a></li>
            </ul>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.2em] text-[#E28721] mb-3">Reach Us</p>
            <ul className="space-y-2 text-[#B4A79A]">
              <li>{CONTACT.owner}</li>
              <li><a href={`tel:${CONTACT.phoneRaw}`} className="hover:text-[#F9F6F0] transition-colors">{CONTACT.phone}</a></li>
              <li>{CONTACT.city}</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="pt-6 flex flex-col sm:flex-row justify-between gap-2 text-[#6f635a] text-xs">
        <span>© {new Date().getFullYear()} Mamta's Kitchen. Made by hand.</span>
        <span>Ghaziabad · Uttar Pradesh · India</span>
      </div>
    </div>
  </footer>
);
